import * as React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ username, onLogout }) => {
    return (
        <header className="header__wrapper clear">
            <div className="logo pull">
            </div>
            
            <nav className="nav push">
                <div className="nav__item">
                    <Link to="/" className="nav__link">
                        Home
                    </Link>
                </div>
                <div className="nav__item">
                    <Link to="/paperworks" className="nav__link">
                        Paperwork Entries
                    </Link>
                </div>
                <div className="nav__item">
                    <a className="nav__link" href="#" onClick={onLogout}>Logout</a>
                </div>
            </nav>
            {/* <span className="type--tiny">You are logged as: {username}</span> */}
        </header>
    )
}

export { Header }


// WEBPACK FOOTER //
// ./src/components/Header.js